import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
type FAQItem = {
  question: string;
  answer: string;
};
const FAQS: FAQItem[] = [{
  question: '¿Qué recibo al comprar Proyecto Organizacional 360?',
  answer: 'Recibís el sistema completo de clases anuales de Proyecto Organizacional, más 2 bonos exclusivos: Mapa Anual del Proyecto (tu GPS para todo el ciclo lectivo) y Evaluaciones Prácticas con Rúbricas Listas. Todo en formato digital (PDF + Word editable) para descargar inmediatamente.'
}, {
  question: '¿Cuándo me llega?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibís un email con las instrucciones para descargar todo el material. Podés empezar a usarlo en menos de 5 minutos.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Todo el material es digital. Después de la compra, te enviamos un link de descarga a tu email. Podés guardar los archivos en tu computadora, tablet o celular, y acceder cuando quieras sin necesidad de internet.'
}, {
  question: '¿Es físico o digital?',
  answer: 'Es 100% digital. No hay envíos físicos. Esto te permite acceder al instante y llevarlo siempre con vos en cualquier dispositivo. Además, podés imprimirlo si preferís trabajar en papel.'
}, {
  question: '¿Necesito ser profesional o tener experiencia?',
  answer: 'No necesitás ser experto ni tener años de experiencia. Proyecto Organizacional 360 está diseñado para docentes de nivel secundario comercial que dictan materias relacionadas con proyectos, economía o administración. Si das clases de Proyecto Organizacional, esto es para vos.'
}, {
  question: '¿Tengo acceso para siempre?',
  answer: 'Sí, el acceso es vitalicio. Una vez que descargás el material, es tuyo para siempre. No hay vencimientos, renovaciones ni pagos mensuales. Comprás una vez y lo usás todos los años que quieras.'
}, {
  question: '¿Qué hago si no me llega el acceso?',
  answer: 'Si no recibís el email en los próximos 10 minutos, revisá tu carpeta de spam. Si aún así no lo encontrás, escribinos a soporte y te lo reenviamos de inmediato. Siempre respondemos en menos de 24 horas.'
}, {
  question: '¿Es una compra segura?',
  answer: 'Totalmente segura. Usamos la plataforma de pago más confiable de Argentina, con encriptación SSL. Aceptamos todas las tarjetas y Mercado Pago. Además, tenés garantía de devolución de 7 días sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 px-4 md:px-8 bg-white relative overflow-hidden" data-id="element-253">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30" data-id="element-254">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-emerald-100 rounded-full blur-3xl" data-id="element-255" />
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-blue-50 rounded-full blur-3xl" data-id="element-256" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-257">
        <div className="text-center mb-16" data-id="element-258">
          <div className="inline-flex items-center justify-center p-3 bg-emerald-100 rounded-full mb-6" data-id="element-259">
            <HelpCircle className="w-6 h-6 text-emerald-600" data-id="element-260" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-261">
            Resolvé aquí tus DUDAS
          </h2>
          <p className="text-xl text-slate-600" data-id="element-262">
            Las preguntas más frecuentes sobre el pack
          </p>
        </div>

        <div className="space-y-4" data-id="element-263">
          {FAQS.map((faq, index) => <div key={index} className={`border rounded-xl transition-all duration-300 ${openIndex === index ? 'border-emerald-500 shadow-lg bg-emerald-50/30' : 'border-slate-200 hover:border-emerald-300 bg-white'}`} data-id="element-264">
              <button onClick={() => toggleIndex(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-inset rounded-xl" aria-expanded={openIndex === index} data-id="element-265">
                <span className={`text-lg font-bold transition-colors ${openIndex === index ? 'text-emerald-800' : 'text-slate-800'}`} data-id="element-266">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className={`flex-shrink-0 ml-4 ${openIndex === index ? 'text-emerald-600' : 'text-slate-400'}`} data-id="element-267">
                  <ChevronDown className="w-6 h-6" data-id="element-268" />
                </motion.div>
              </button>

              <AnimatePresence initial={false} data-id="element-269">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-270">
                    <div className="px-6 pb-6 pt-0 text-slate-600 leading-relaxed" data-id="element-271">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}